var exports = {
  "i": "diffPreview__yaVH_f",
};

module.exports = exports;
